import React from 'react';
import { Reveal } from './Reveal';
import { SlideFrame } from './SlideFrame';
const route = ['Venue', 'Aisle', 'Booth', 'Conversation'];
const purpose = ['Bring the story into the venue', 'Move from aisle to booth', 'Turn curiosity into dialogue', 'Let the HCP shape the route', 'Make every interaction more relevant'];
export function ActTwoDuringSlide() {
  return <SlideFrame topBand data-id="element-41" data-mp="w2c6kewecqf">
      <div className="flex items-center gap-[1vw] font-sans text-[clamp(13px,1.05vw,20px)] font-semibold tracking-[0.16em]" data-id="element-42" data-mp="wlmbeyb3wtw">
        <span className="text-black/35" data-id="element-43" data-mp="5tbz9tetecb3">Act II</span>
        <span className="h-px w-[clamp(28px,3vw,54px)] bg-[#D62B22]" data-id="element-44" data-mp="9vyv05elwhdk" />
        <span className="text-[#D62B22]" data-id="element-45" data-mp="9unse8wwdfo1">During</span>
      </div>

      <header className="mt-[2.4vh] flex items-end justify-between gap-[5vw]" data-id="element-46" data-mp="eua248diods3">
        <h1 className="max-w-[11ch] font-display text-[clamp(55px,7vw,116px)] font-bold leading-[0.92] tracking-[-0.03em]" data-id="element-47" data-mp="2bowtagr5k25w">
          Create the conversation
        </h1>
        <p className="mb-[0.8vh] max-w-[26ch] font-display text-[clamp(20px,2vw,34px)] font-medium leading-[1.12] text-black/55" data-id="element-48" data-mp="3bc4pxwe8afzq">
          The congress is where the narrative comes alive.
        </p>
      </header>

      <div className="relative mt-[4vh] px-[1vw] py-[2.2vh]" data-id="element-49" data-mp="32jjhb94b9pom">
        <div className="absolute left-[3%] right-[3%] top-1/2 h-[clamp(3px,0.35vw,6px)] -translate-y-1/2 bg-[#D62B22]" data-id="element-50" data-mp="32hoxxz8ou5mn" />
        <div className="relative z-10 grid grid-cols-4" data-id="element-51" data-mp="3uaz3j21yhaeb">
          {route.map((place, index) => <Reveal key={place} delay={0.06 + index * 0.06} className="flex items-center" data-id="element-52" data-mp="3q9x52nfv52de" data-mpi={index}>
              <span className="flex size-[clamp(36px,3.8vw,68px)] items-center justify-center rounded-full border-[clamp(3px,0.3vw,5px)] border-[#D62B22] bg-[#F4F1E8] font-sans text-[clamp(11px,0.9vw,17px)] font-semibold text-black" data-id="element-53" data-mp="3laapw8gh5c1y">
                0{index + 1}
              </span>
              <p className="ml-[1vw] bg-[#F4F1E8] pr-[1vw] font-display text-[clamp(20px,2vw,36px)] font-semibold" data-id="element-54" data-mp="29t19jusn704v">{place}</p>
            </Reveal>)}
        </div>
      </div>

      <div className="mt-[3vh] grid grid-cols-5 border-y border-black/20 py-[2.2vh]" data-id="element-55" data-mp="26e9jjzml3cq2">
        {purpose.map((message, index) => <div key={message} className={`pr-[1.4vw] ${index > 0 ? 'border-l border-black/15 pl-[1.4vw]' : ''}`} data-id="element-56" data-mp="1xd1um85yjo8n" data-mpi={index}>
            <p className="max-w-[12ch] font-display text-[clamp(18px,1.8vw,32px)] font-medium leading-[1.08] text-black/70" data-id="element-57" data-mp="22bd2idcozoo8">
              {message}
            </p>
          </div>)}
      </div>

      <Reveal className="mt-auto border-t-[clamp(3px,0.3vw,5px)] border-[#D62B22] pt-[2vh]" delay={0.12} data-id="element-58" data-mp="1sdyosli5ldzm">
        <p className="max-w-[30ch] font-display text-[clamp(27px,3vw,52px)] font-semibold leading-[1.04]" data-id="element-59" data-mp="1en3f56ztysuz">
          At ECCO, the audience should not just watch the play. <span className="text-[#D62B22]" data-id="element-60" data-mp="14o4di8dhfxhh">They should enter it.</span>
        </p>
      </Reveal>
    </SlideFrame>;
}